import { AutomationsApi } from '@src/services/automations/automations-api';
import { BrainApi } from '@src/services/brain/brain-api';
import { RetrySettings } from '@src/services/api-instance';
import { SearchRunsParams, AggregateRunsParams } from '@src/services/automations/modules/v1/requests/requests.service';
import { SearchRunsResponseDTO } from '@src/services/automations/modules/v1/requests/dto/requests.search.response.dto';
import { AggregateRunsResponseDTO } from '@src/services/automations/modules/v1/requests/dto/requests.aggregate.response.dto';
import { RequestGetByIdResponseDTO } from '@src/services/automations/modules/v1/requests/dto/requests.getById.response.dto';

const automations = new AutomationsApi();
const brain = new BrainApi();

const NO_RETRY: RetrySettings = { maxRetries: 0, retryDelay: 0, delayType: 'linear' };

export const getRuns = async (params: SearchRunsParams): Promise<SearchRunsResponseDTO> => {
  return automations.v1.requests.search({ params, settings: params.contextSearch ? NO_RETRY : undefined });
};

export const getRunsAggregate = async (params: AggregateRunsParams): Promise<AggregateRunsResponseDTO> => {
  return automations.v1.requests.aggregate({ params });
};

export const getRunById = async (id: string): Promise<RequestGetByIdResponseDTO> => {
  return automations.v1.requests.getById({ id });
};

export const createRunRerun = async (id: string): Promise<{ message: string }> => {
  return brain.v1.runs.postRerun({ id });
};

export const getTaskIdByRequestId = async (requestId: string, organizationId?: string): Promise<string | null> => {
  const res = await brain.v1.tasks.get({ params: { requestId, organizationId, type: ['ERROR'], limit: 1 } });
  return res.items[0]?.id ?? null;
};
